
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
  @Component({ 
    components: {} 
  })
export default class AddStorage extends Vue {
    @Prop() dialogModel: boolean
    @Prop() format: any
    @Prop() modelType: string

    @Watch('dialogModel')
    getDialog(newVal, oldVal) {
      if (newVal) {
        if (this.modelType === 'add') {
          this.title = '新建'
        } else {
          this.title = '编辑'
        }
      }
    }

    title: string = ''


    close() {
      this.$emit('add-model', { type: false, val: this.format })
    }
    submit() {
      this.$emit('add-model', { type: true, val: this.format })
    }

    mounted() {
     
    }
}
